import rowEditMixin from "@/components/common/mini-table/mixins/row-edit-mixin";

export default {
    mixins: [rowEditMixin],
    props: {
        //开启table tree模式
        enableTableTree: {
            type: Boolean,
            default: false
        },
        treeIdName: String,
        treeNodeLabelName: String,
        treeParentIdName: String,
        treeLevelName: {
            type: String,
            default: 'level'
        },
        expendAll: {
            type: Boolean,
            default: false
        },
        defaultExpendDepth: Number,
        withoutLevel: {
            type: Boolean,
            default: false
        },
        //将children平铺至list中
        breakChildren: {
            type: Boolean,
            default: false
        },
        enableTreeCheck: {
            type: Boolean,
            default: false
        },
        treeCheckMode: {
            type: String,
            default: "C"//with (C: children,N: none) 未支持模式：(PC: parents&children,P: parents)
        }
    },
    computed: {
        tableTreeValid() {
            return this.enableTableTree && this.treeIdName && this.treeParentIdName && !this.generateTreeFailed;
        },
        tableTreeNodeName() {
            return this.treeNodeLabelName ? this.treeNodeLabelName : this.treeIdName;
        },
    },
    data() {
        return {
            //-----table tree
            headerRows: [],
            rowTreeMap: new Map(),
            expendedTreeNode: new Set(),
            changeFlag: 0,
            generateTreeFailed: false,
            expendDepth: -1,
            maxDepth: -1,
            //---
            levelMap: new Map(),

            nodeCheckStatus: {},
        }
    },
    watch: {
        expendDepth() {
            if (this.enableTableTree && this.initFinish) {
                this.changeExpendByDepth();
            }
        },
    },
    created() {
        if (this.defaultExpendDepth) {
            this.expendDepth = this.defaultExpendDepth;
        }
    },
    methods: {
        //解析tree结构
        generateTreeStructure() {
            if (this.withoutLevel) {
                this.generateWithoutLevel();
            } else {
                this.generateWithLevel();
            }
        },
        getRowList() {
            if (this.breakChildren) {
                let tempList = [];
                for (let row of this.rowListCover) {
                    this.backtraceChildren(tempList, row);
                }
                return tempList;
            } else {
                return this.rowListCover;
            }
        },
        backtraceChildren(list, node) {
            list.push(node);
            if (node.children) {
                for (let row of node.children) {
                    this.backtraceChildren(list, row);
                }
                node.children = null;
            }
        },
        generateWithLevel() {
            let tempMap = new Map();
            let headList = [];
            for (let row of this.getRowList()) {
                let level = row[this.treeLevelName];
                if (isNaN(level)) {
                    this.generateTreeFailed = true;
                    return;
                }
                if (level > this.maxDepth) {
                    this.maxDepth = level;
                }
                let parentId = row[this.treeParentIdName];
                if (this.hasCode(parentId)) {
                    let key = parentId + '_' + Number.parseInt(level + '');//parentId + level
                    if (tempMap.has(key)) {
                        tempMap.get(key).push(row);
                    } else {
                        tempMap.set(key, [row]);
                    }
                }
                if (level === 0) {
                    headList.push(row);
                }
                if (this.expendAll ||
                    this.expendDepth !== undefined && this.expendDepth != null && level < this.expendDepth) {
                    this.expendedTreeNode.add(this.getRowTreeNodeId(row));
                }
            }
            if (this.maxDepth === -1) {
                this.generateTreeFailed = true;
            }
            this.headerRows = headList;
            this.rowTreeMap = tempMap;
        },
        //递归显示的行
        backtraceTreeRowList(result, tempList) {
            for (let row of tempList) {
                result.push(row);
                let id = this.getRowTreeNodeId(row);
                if (this.hasCode(id) && this.expendedTreeNode.has(id) && this.rowTreeMap.has(id)) {
                    this.backtraceTreeRowList(result, this.rowTreeMap.get(id));
                }
            }
        },
        //切换tree行的折叠/展开
        triggerRowExpend(row) {
            let id = this.getRowTreeNodeId(row);
            if (this.expendedTreeNode.has(id)) {
                this.expendedTreeNode.delete(id);
                this.changeFlag--;
            } else {
                this.expendedTreeNode.add(id);
                this.changeFlag++;
            }
        },
        tableTreeNodeWidthOffset(row) {
            let level = this.withoutLevel
                ? this.levelMap.get(row[this.treeParentIdName])
                : Number.parseInt(row[this.treeLevelName])
            if (!level) {
                level = 0;
            }
            return `width: ${level}rem`;
        },
        getRowTreeNodeId(row) {
            if (this.withoutLevel) {
                return row[this.treeIdName];
            }
            return row[this.treeIdName] + '_' + (Number.parseInt(row[this.treeLevelName]) + 1);
        },
        treeNodeHasChild(row) {
            let key = this.getRowTreeNodeId(row);
            return this.rowTreeMap.has(key);
        },
        changeExpendByDepth() {
            if (this.expendDepth !== undefined && this.expendDepth != null) {
                let temp = new Set();
                for (let id of Array.from(this.rowTreeMap.keys())) {
                    let level;
                    if (this.withoutLevel) {
                        level = this.levelMap.get(id);
                    } else {
                        level = Number.parseInt(id.substring(id.lastIndexOf('_') + 1));
                    }
                    if (level && level <= this.expendDepth) {
                        temp.add(id);
                    }
                }
                this.expendedTreeNode = temp;
            }
        },
        //------
        generateWithoutLevel() {
            let tempMap = new Map();
            let headList = [];
            for (let row of this.getRowList()) {
                let parentId = row[this.treeParentIdName];
                if (this.hasCode(parentId) && parentId !== 0) {
                    if (tempMap.has(parentId)) {
                        tempMap.get(parentId).push(row);
                    } else {
                        tempMap.set(parentId, [row]);
                    }
                } else if (parentId === 0) {
                    headList.push(row);
                } else {
                    this.generateTreeFailed = true;
                    return;
                }
                if (this.expendAll) {
                    this.expendedTreeNode.add(this.getRowTreeNodeId(row));
                }
            }
            //
            if (headList.length === 0) {
                let list = this.getRowList();
                let idSet = new Set();
                for (let row of list) {
                    idSet.add(row[this.treeIdName]);
                }
                for (let row of list) {
                    let parentId = row[this.treeParentIdName];
                    if (!idSet.has(parentId)) {
                        headList.push(row);
                    }
                }
            }
            this.levelMap = new Map();
            for (let header of headList) {
                this.backtraceLevel(header, tempMap, 1);
            }
            for (let level of this.levelMap.values()) {
                if (level > this.maxDepth) {
                    this.maxDepth = level;
                }
            }
            if (this.maxDepth === -1) {
                this.generateTreeFailed = true;
            }
            this.headerRows = headList;
            this.rowTreeMap = tempMap;
        },
        backtraceLevel(node, treeMap, currentLevel) {
            let nodeId = this.getRowTreeNodeId(node);
            if (treeMap.has(nodeId)) {
                this.levelMap.set(nodeId, currentLevel);
                let children = treeMap.get(nodeId);
                if (children && this.expendDepth !== undefined && this.expendDepth != null && currentLevel <= this.expendDepth) {
                    this.expendedTreeNode.add(nodeId);
                }
                for (let item of children) {
                    this.backtraceLevel(item, treeMap, currentLevel + 1);
                }
            }
        },
        //-----
        handleTreeCheckEvent(checked, row) {
            this.changeAllChildrenCheckStatus(row, checked);
            this.emitCheckEvent();
        },
        changeAllChildrenCheckStatus(row, checked) {
            let id = this.changeTreeCheckStatus(row, checked);
            switch (this.treeCheckMode) {
                case 'C':
                    if (this.rowTreeMap.has(id)) {
                        for (let item of this.rowTreeMap.get(id)) {
                            this.changeAllChildrenCheckStatus(item, checked);
                        }
                    }
                    break;
                case 'N':
                    break;
            }
        },
        changeTreeCheckStatus(row, checked) {
            this.changeRowCheckStatus(row, checked);
            let id = this.getRowTreeNodeId(row);
            this.$set(this.nodeCheckStatus, id, checked);
            return id;
        },
    }
}
